import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-semantic-yes',
  templateUrl: './disable-semantic-yes.component.html',
  styleUrls: ['./disable-semantic-yes.component.css'],
})
export class DisableSemanticYesComponent {
  @Input() question!: Question;
}
